import React from 'react';
import styled from 'styled-components';
import { CareerHeader, Hire, Opinion, Process } from '../../Sections/sec';

const Career = () => {
  return (
    <CareerWrapper>
      <CareerHeader />
      <Opinion />
      <Hire />
      <Process />
    </CareerWrapper>
  );
};

const CareerWrapper = styled.section`
  overflow-x: hidden;
`;

export default Career;
